import mixpanel from 'mixpanel-browser';
import { reactive, readonly } from 'vue';
import { useRoute } from 'vue-router';

const mixpanelOptions = reactive({});

export function useMixpanel() {
  const route = useRoute();

  function init(userData = {}, options = {}) {
    if (typeof mixpanel === 'undefined') {
      return;
    }

    Object.assign(mixpanelOptions, options);
    const { id, ...rest } = userData;
    if (!id) {
      return;
    }

    mixpanel.identify(id);
    mixpanel.people.set({
      ...rest,
      distinct_id: id,
    });
  }

  function trackEvent(eventName, payload = {}, customRoute = null) {
    const currentRoute = customRoute || route;
    if (!mixpanel || !currentRoute) {
      return;
    }

    const { fullPath, meta, params, query } = currentRoute;

    mixpanel.track(eventName, {
      fullPath,
      pageName: meta.mixpanelPageName ?? meta.pageTitle ?? '',
      params,
      queryParams: query,
      queryParamsKeys: Object.keys(query),
      ...payload,
    });
  }

  function reset() {
    if (!mixpanel) {
      return;
    }
    trackEvent('Logged out');
    mixpanel.reset();
  }

  return {
    init,
    mixpanelTrackEvent: trackEvent,
    options: readonly(mixpanelOptions),
    reset,
  };
}
